import { apiKeys } from "./app/services/apiKeys";
import { Tracking } from "./features/shared/Tracking";

export const AppTracking = () => (
  <Tracking didomiApiKey={apiKeys.value.didomi} gtmApiKey={apiKeys.value.gtm} />
);
